import React from 'react';
import { Box, Typography } from '@mui/material';
import { BRAND, brandAlpha } from '../../theme/brandTokens';
import { formatCurrency } from '../../utils/currencyUtils';

const TONES = {
  keep: {
    backgroundColor: brandAlpha('primary', 0.08),
    borderColor: brandAlpha('primary', 0.28),
    valueColor: BRAND.primaryText,
  },
  cost: {
    backgroundColor: brandAlpha('accent', 0.1),
    borderColor: brandAlpha('accent', 0.34),
    valueColor: BRAND.accentText,
  },
};

const SummaryStatCard = ({
  label,
  value,
  currencyCode,
  formattedValue,
  emphasizeNegative = false,
  tone,
}) => {
  const isNegative = emphasizeNegative && Number(value) < 0;
  const toneStyle = !isNegative && tone ? TONES[tone] : null;
  const display = formattedValue ?? (currencyCode != null ? formatCurrency(value, currencyCode) : value);

  return (
    <Box
      sx={{
        p: { xs: 1.25, sm: 2 },
        borderRadius: 2,
        border: '1px solid',
        borderLeftWidth: toneStyle || isNegative ? 4 : 1,
        borderColor: isNegative ? 'error.light' : (toneStyle?.borderColor ?? BRAND.line),
        backgroundColor: isNegative ? 'error.light' : (toneStyle?.backgroundColor ?? BRAND.background),
        minWidth: 0,
        height: '100%',
        flex: tone ? undefined : '1 1 180px',
      }}
    >
      <Typography
        variant="caption"
        color="text.secondary"
        sx={{ display: 'block', mb: 0.5, lineHeight: 1.35 }}
      >
        {label}
      </Typography>
      <Typography
        sx={{
          fontWeight: 700,
          fontSize: { xs: '1rem', sm: '1.15rem' },
          lineHeight: 1.25,
          overflowWrap: 'anywhere',
          color: isNegative ? 'error.dark' : (toneStyle?.valueColor ?? BRAND.primaryText),
        }}
      >
        {display}
      </Typography>
    </Box>
  );
};

export const SummaryStatGrid = ({ children, sx }) => (
  <Box
    sx={{
      display: 'grid',
      gap: { xs: 1, sm: 1.5 },
      gridTemplateColumns: {
        xs: 'repeat(2, minmax(0, 1fr))',
        lg: 'repeat(auto-fit, minmax(200px, 1fr))',
      },
      '& > :last-child:nth-child(odd)': {
        gridColumn: { xs: '1 / -1', lg: 'auto' },
      },
      ...sx,
    }}
  >
    {children}
  </Box>
);

export default SummaryStatCard;
